var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 43,
    viewBox: "0 0 56 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(0 .286)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8,
    height: 35.538,
    x: 7.2,
    fill: "#FFDCE3",
    rx: 3.888
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M1.889 18.74c-.622-.354-1.398-.11-1.735.543-.336.655-.104 1.472.517 1.825l20.823 11.845c.354.201.776.216 1.141.04l24.617-11.845c.643-.309.926-1.108.632-1.784-.294-.677-1.054-.974-1.697-.665L22.151 30.265 1.889 18.739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M46.232 15.422v-.885a1.727 1.727 0 0 0-1.382-1.412H3.95a1.73 1.73 0 0 0-1.393 1.487 1.29 1.29 0 0 1-1.443 1.126c-.703-.096-1.197-.756-1.102-1.475.256-1.953 1.759-3.49 3.67-3.751.057-.008.114-.012.17-.012h41.095c.057 0 .114.004.17.012 1.912.261 3.416 1.798 3.672 3.751.007.058.011.116.011.175v23.624c0 .059-.004.117-.011.175-.256 1.953-1.76 3.49-3.671 3.751a1.257 1.257 0 0 1-.17.012H3.852l-.09-.003c-2.015-.144-3.62-1.783-3.76-3.843L0 38.062V19.689c0-.725.575-1.313 1.284-1.313.71 0 1.285.588 1.285 1.313V38.01a1.5 1.5 0 0 0 1.335 1.365H44.85a1.727 1.727 0 0 0 1.382-1.412V15.422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic-mail.aadfce05513bb73a794ad9974db54bcb.svg";
export { ForwardRef as ReactComponent };